import React, { useContext, useEffect } from "react";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { ToggleConfigurar } from "../../Toggle/ToggleConfigurar/ToggleConfigurar";
import { ContainerEntregaRetirada } from "./styles";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { AuthContext } from "../../../contexts/Auth/AuthContext";
import LockedIcon from "../../LockedIcon/LockedIcon";

interface EntregaRetiradaProps {
  onConfigurarCorreios: () => void;
  onConfigurarEntregaLocal: () => void;
  onConfigurarFreteEspecial: (length: number) => void;
  onConfigurarFreteGratis: (length: number) => void;
  onConfigurarRetiradaNoLocal: () => void;
}

const EntregaRetirada: React.FC<EntregaRetiradaProps> = ({
  onConfigurarCorreios,
  onConfigurarFreteEspecial,
  onConfigurarEntregaLocal,
  onConfigurarFreteGratis,
  onConfigurarRetiradaNoLocal,
}) => {
  const { configuracoes, setConfiguracoes, fretes_gratis, fretes_especiais } =
    useContext(ConfiguracoesContext);

    
  const { permissoesPlanos } = useContext(AuthContext);

  const { theme } = useTheme();

  return (
    <>
      <ContainerEntregaRetirada theme={theme}>
        <div className="containerEntregaRetirada">
          <Titulo
            justifyContent="center"
            flexDirection="column-reverse"
            titulo="Entrega e Retirada"
            subtitulo={`Selecione o tipo de frete a ser <br/>calculado no fechamento do pedido.`}
          />
          <div className="entrega">
            <div className="titulo fonteSubtitulo">Entrega</div>
            <ToggleConfigurar
              nome="Correios"
              Icon={permissoesPlanos["INTEGRACAO_COM_OS_CORREIOS"]?.permitido ? undefined : LockedIcon}
              value={configuracoes.frete.correiosAtivo}
              disabled={!permissoesPlanos["INTEGRACAO_COM_OS_CORREIOS"]?.permitido}
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  frete: {
                    ...configuracoes.frete,
                    ["correiosAtivo"]: newValue,
                  },
                });
              }}
              onConfigurar={onConfigurarCorreios}
            />

            <ToggleConfigurar
              nome="Entrega local"
              value={configuracoes.frete.entregaLocal.ativo}
              Icon={permissoesPlanos["ENTREGA_LOCAL_COM_E_SEM_TAXA"]?.permitido ? undefined : LockedIcon}
              disabled={!permissoesPlanos["ENTREGA_LOCAL_COM_E_SEM_TAXA"]?.permitido}
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  frete: {
                    ...configuracoes.frete,
                    ["entregaLocal"]: {
                      ...configuracoes.frete["entregaLocal"],
                      ativo: newValue,
                    },
                  },
                });
              }}
              onConfigurar={onConfigurarEntregaLocal}
            />

            <ToggleConfigurar
              nome="Entrega especial"
              value={configuracoes.frete.freteEspecialAtivo}
              Icon={permissoesPlanos["ENTREGA_ESPECIAL"]?.permitido ? undefined : LockedIcon}
              disabled={!permissoesPlanos["ENTREGA_ESPECIAL"]?.permitido}
              isValid={(newValue) =>
                (fretes_especiais.length === 0 ||
                  !fretes_especiais.some((frete) => frete.ativo)) &&
                configuracoes.frete.freteEspecialAtivo
                  ? false
                  : true
              }
              invalidText="Você precisa configurar um frete especial <br/> para ter essa opção ativa."
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  frete: {
                    ...configuracoes.frete,
                    ["freteEspecialAtivo"]: newValue,
                  },
                });
              }}
              onConfigurar={() =>
                onConfigurarFreteEspecial(fretes_especiais.length)
              }
            />

            <ToggleConfigurar
              nome="Frete grátis"
              value={configuracoes.frete.freteGratisAtivo}
              Icon={permissoesPlanos["FRETE_GRATIS"]?.permitido ? undefined : LockedIcon}
              disabled={!permissoesPlanos["FRETE_GRATIS"]?.permitido}
              isValid={(newValue) =>
                (fretes_gratis.length === 0 ||
                  !fretes_gratis.some((frete) => frete.ativo)) &&
                configuracoes.frete.freteGratisAtivo
                  ? false
                  : true
              }
              invalidText="Você precisa configurar um frete grátis <br/> para ter essa opção ativa."
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  frete: {
                    ...configuracoes.frete,
                    ["freteGratisAtivo"]: newValue,
                  },
                });
              }}
              onConfigurar={() => onConfigurarFreteGratis(fretes_gratis.length)}
            />
          </div>
          <div className="retirada">
            <div className="titulo fonteSubtitulo">Retirada</div>
            <ToggleConfigurar
              nome="No local"
              value={configuracoes.frete.retirada_no_local.ativo}
              Icon={permissoesPlanos["RETIRADA_LOCAL"]?.permitido ? undefined : LockedIcon}
              disabled={!permissoesPlanos["RETIRADA_LOCAL"]?.permitido}
              isValid={(newValue) =>
                configuracoes.frete.retirada_no_local.ativo &&
                !configuracoes.frete.retirada_no_local.intervalos.some(
                  (intervalo) => intervalo.dias.length,
                )
                  ? false
                  : true
              }
              invalidText="Você precisa configurar pelo menos um dia <br/> para ter essa opção ativa."
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  frete: {
                    ...configuracoes.frete,
                    ["retirada_no_local"]: {
                      ...configuracoes.frete["retirada_no_local"],
                      ativo: newValue,
                    },
                  },
                });
              }}
              onConfigurar={onConfigurarRetiradaNoLocal}
            />
          </div>
        </div>
      </ContainerEntregaRetirada>
    </>
  );
};
export default EntregaRetirada;
